export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ23.efee5320.mp3";